import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class ChatMessage extends AbstractModel {
  @autoserialize
  reservationId: number;

  @autoserialize
  senderPersonId: number;

  @autoserialize
  recipientPersonId: number;

  @autoserialize
  text: string;

  @autoserialize
  read: boolean;
}
